import { Company, SimpleLatLng } from "@mysnowscape/snow-lib";

export default function primaryLocation(
  company: Pick<Company, "locations" | "fallbackInferredLocation">,
): SimpleLatLng | null {
  if (company.locations && company.locations.length > 0) {
    const primary = company.locations.find((l) => l.primary === true);
    if (primary) {
      return primary.location;
    }
    return company.locations[0].location;
  }
  if (company.fallbackInferredLocation) {
    return company.fallbackInferredLocation;
  }
  return null;
}
